<template>
    <div>
        <div v-if="userCanRateSubscription" class="container mx-auto md:flex">
            <div class="divider--container w-full md:w-1/2 flex items-center justify-center md:p-4 md:pt-6">
                <div class="divider-white--top visible md:invisible z-10"></div>
                <div class="accountRateFlowersThumb__container"
                     :style="thumbStyle">
                    <delivery-date-box
                        class="accountRateFlowersThumb__dateIcon"
                        :date="new Date(this.arrangementToRate.order.delivery_date)">
                    </delivery-date-box>
                </div>
                <div class="divider-paper--bottom visible md:invisible"></div>
            </div>
            <div class="w-full md:w-1/2 p-4 pt-6">
                <rate-flowers-form
                    :order-id="arrangementToRate.order.id">
                </rate-flowers-form>
            </div>
        </div>
        <div v-else class="container mx-auto text-center p-4 py-8">
            <div class="w-full md:w-4/5 mx-auto">
                <h2 v-text="$t('RATE_ARRANGEMENT_NO_FLOWERS')"></h2>
                <p v-text="$t('RATE_ARRANGEMENT_WE_ARE_LOVING')"></p>
                <p v-text="$t('RATE_ARRANGEMENT_A_LOOSE')"></p>
                <router-link class="btn btn--primary mt-2" :to="{name: 'account.free-flowers'}">
                    {{ $t('RATE_ARRANGEMENT_FREE_FLOWERS') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import DeliveryDateBox from '@/components/structure/DeliveryDateBox';
import RateFlowersForm from '@/components/forms/account/RateFlowersForm';

export default {
    name: 'RateArrangement',
    computed: {
        activeSubscription() {
            return this.$store.getters['subscription/getActiveSubscription'];
        },

        arrangementsUserCanRate() {
            return this.$store.getters['cms/getRateableArrangements'];
        },

        arrangementToRate() {
            return (this.arrangementsUserCanRate || [])
                .find(item => item.subscription.id === this.activeSubscription.id);
        },

        userCanRateSubscription() {
            return typeof this.arrangementToRate !== 'undefined';
        },
        thumbStyle() {
            let src = this.arrangementToRate.image_url;

            return `background-image: url(${src})`;
        },
    },
    components: {
        RateFlowersForm,
        DeliveryDateBox,
    },
};
</script>
